import { createContext, useCallback, useRef, useState } from "react";

export const VideoContext = createContext()

export const VideoContextProvider = ({ children, onTogglePlayPause }) => {
    const videoRef = useRef()
    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false)
    const [isMuted, setIsMuted] = useState(false)
    const [currentTime, setCurrentTime] = useState(0)
    const [duration, setDuration] = useState(0)
    const seekTo = useCallback((timeInSeconds) => {
        if (!videoRef.current) return
        const newTime = Math.max(0, Math.min(timeInSeconds, duration));
        videoRef.current.currentTime = newTime;
    }, [duration])
    // 播放/暂停控制
    const togglePlayPause = useCallback(() => {
        const video = videoRef.current
        if (!video) return;
        // 同步模式下交由画布中心在本次用户点击内直接控制整组视频，以保留浏览器用户激活权限。
        if (onTogglePlayPause) {
            onTogglePlayPause()
        } else if (video.paused) {
            video.play().catch(error => {
                console.error('播放失败:', error);
            });
        } else {
            video.pause();
        }
    }, [onTogglePlayPause]);
    // 静音仅作用于当前画布的视频，不跟随同步锁传播到其他对比视频。
    const toggleMute = useCallback(() => {
        setIsMuted(prev => !prev)
    }, [])
    return (
        <VideoContext.Provider value={{
            videoRef,
            isLoading,
            setIsLoading,
            isPlaying,
            setIsPlaying,
            isMuted,
            setIsMuted,
            currentTime,
            setCurrentTime,
            duration,
            setDuration,
            seekTo,
            togglePlayPause,
            toggleMute,
        }}>
            {children}
        </VideoContext.Provider>
    )
}
